import { MLMData } from './mlmActionIds.enum'

export const staticMlmTrackingData: {
    affiliateId: number | string
    itemChannel: string
} = {
    affiliateId: MLMData.AFFILIATE_ID,
    itemChannel: MLMData.ITEM_CHANNEL as string,
}
